














import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      b1Text: "Challenges",
      b2Text: "Info Packages",
      b3Text: "Schedule",
      b1Link: "https://deltahacks7.devpost.com/",
      b2Link: "AttendeeInformation.pdf",
      b3Link: "DH7Schedule.pdf",
    };
  },
});
